import { Cidade } from "../../endereco.model";
import { Frota } from "./frota.model";

export class Cia {
    Id: number = 0;
    Nome: string;
    CNPJ: string;
    Ativo: boolean;
    TelefonePrincipal: string;
    TelefoneSecundario: string;
    Email: string;
    Cep: string;
    Logradouro: string;
    Numero: string;
    Complemento: string;
    Bairro: string;
    Cidade: Cidade = new Cidade();
    CidadeId: number;
    Frota: Frota[] = [];
}